// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WelcomePage.css - Exact Figma Layout */

.welcome-page {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 56px);
  background-color: #FFFFFF;
  overflow: auto;
}

/* Content wrapper - positions card and text side by side */
.welcome-content-wrapper {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 64px;
  padding: 32px;
  width: 100%;
  box-sizing: border-box;
}

/* Challenge Card - fixed size from Figma */
.challenge-card {
  width: 546px;
  height: 473px;
  flex: 0 0 546px;
  border-radius: 40px;
  overflow: hidden;
}

.challenge-card-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* Text Content - takes remaining space */
.welcome-text-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  min-width: 300px;
  max-width: 800px;
}

.welcome-title {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 900;
  font-size: 48px;
  line-height: 1.2;
  letter-spacing: -0.005em;
  color: #236CFF;
  margin: 0;
}

.welcome-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.welcome-body p {
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  font-size: 18px;
  line-height: 1.6;
  color: #21262A;
  margin: 0;
}

/* Get Started Button - exact Figma specs */
.btn-get-started {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 136px;
  height: 48px;
  padding: 10px 24px;
  background-color: #00254B;
  border: none;
  border-radius: 9999px;
  cursor: pointer;
  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.75;
  color: #FFFFFF;
  transition: background-color 0.2s ease;
}

.btn-get-started:hover {
  background-color: #001a35;
}

.btn-get-started:focus {
  outline: 2px solid #1C60EA;
  outline-offset: 2px;
}

/* Decorative illustration */
.welcome-illustration {
  position: absolute;
  width: 379px;
  height: 250px;
  left: calc(32px + 245px);
  top: calc(32px + 328px);
  object-fit: contain;
  pointer-events: none;
  z-index: 1;
}

/* Responsive - stack on smaller screens */
@media (max-width: 1100px) {
  .welcome-content-wrapper {
    flex-direction: column;
    gap: 32px;
  }

  .challenge-card {
    width: 100%;
    max-width: 546px;
    height: auto;
    flex: 0 0 auto;
    aspect-ratio: 546 / 473;
  }

  .welcome-text-content {
    max-width: 100%;
  }

  .welcome-title {
    font-size: 36px;
  }

  .welcome-illustration {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/WelcomePage.css"],"names":[],"mappings":"AAAA,yCAAyC;;AAEzC;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,yBAAyB;EACzB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,kFAAkF;EAClF,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* WelcomePage.css - Exact Figma Layout */\n\n.welcome-page {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: calc(100vh - 56px);\n  background-color: #FFFFFF;\n  overflow: auto;\n}\n\n/* Content wrapper - positions card and text side by side */\n.welcome-content-wrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 64px;\n  padding: 32px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Challenge Card - fixed size from Figma */\n.challenge-card {\n  width: 546px;\n  height: 473px;\n  flex: 0 0 546px;\n  border-radius: 40px;\n  overflow: hidden;\n}\n\n.challenge-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* Text Content - takes remaining space */\n.welcome-text-content {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  flex: 1;\n  min-width: 300px;\n  max-width: 800px;\n}\n\n.welcome-title {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 900;\n  font-size: 48px;\n  line-height: 1.2;\n  letter-spacing: -0.005em;\n  color: #236CFF;\n  margin: 0;\n}\n\n.welcome-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.welcome-body p {\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1.6;\n  color: #21262A;\n  margin: 0;\n}\n\n/* Get Started Button - exact Figma specs */\n.btn-get-started {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 136px;\n  height: 48px;\n  padding: 10px 24px;\n  background-color: #00254B;\n  border: none;\n  border-radius: 9999px;\n  cursor: pointer;\n  font-family: 'AvenirNext forINTUIT', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 1.75;\n  color: #FFFFFF;\n  transition: background-color 0.2s ease;\n}\n\n.btn-get-started:hover {\n  background-color: #001a35;\n}\n\n.btn-get-started:focus {\n  outline: 2px solid #1C60EA;\n  outline-offset: 2px;\n}\n\n/* Decorative illustration */\n.welcome-illustration {\n  position: absolute;\n  width: 379px;\n  height: 250px;\n  left: calc(32px + 245px);\n  top: calc(32px + 328px);\n  object-fit: contain;\n  pointer-events: none;\n  z-index: 1;\n}\n\n/* Responsive - stack on smaller screens */\n@media (max-width: 1100px) {\n  .welcome-content-wrapper {\n    flex-direction: column;\n    gap: 32px;\n  }\n\n  .challenge-card {\n    width: 100%;\n    max-width: 546px;\n    height: auto;\n    flex: 0 0 auto;\n    aspect-ratio: 546 / 473;\n  }\n\n  .welcome-text-content {\n    max-width: 100%;\n  }\n\n  .welcome-title {\n    font-size: 36px;\n  }\n\n  .welcome-illustration {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
